import { styled } from "styled-components";

import { Image as ImageIcon } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { Flex } from "@similarweb/ui-components/foundations";

import { POST_MODAL_CONTENT_HEIGHT } from "../constants";

const PreviewContainer = styled(Flex)`
    width: 300px;
    height: ${POST_MODAL_CONTENT_HEIGHT};
    background-color: ${colorsPalettes.carbon[25]};
    border-radius: 6px;
    position: relative;
    justify-content: center;
    align-items: center;
    padding: 16px;
    flex-shrink: 0;
`;

const PreviewImage = styled.img`
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
`;

export const ImagePreviewSection = ({ assetUrl }: { assetUrl?: string }) => {
    if (!assetUrl) {
        return (
            <PreviewContainer>
                <ImageIcon
                    size="xxl"
                    color={colorsPalettes.carbon[200]}
                />
            </PreviewContainer>
        );
    }

    return (
        <PreviewContainer>
            <PreviewImage
                loading="lazy"
                src={assetUrl}
                alt="Creative preview"
            />
        </PreviewContainer>
    );
};
